import {BaseTerms} from "../../../../infrastructure/models/base-terms";

export class GameInfoModuleTerms extends BaseTerms {
  INFO_GAME_MAIN = "Game Info";
  GAME_CENTER_TV_CHANNEL = "TV Channels";
  GAME_CENTER_STADIUM = "Stadium";
  GAME_CENTER_STADIUM_SPORTID_3 = "Venue";
  GAME_CENTER_REFEREE = "Referee";
  GAME_CENTER_ATTENDANCE = "Match Attendance";
  GC_CAPACITY = "Capacity";
  GAME_INFO_SEE_STADIUM = "See stadium on map";
}
